import React, { useState, useEffect } from 'react';

const API_URL = process.env.REACT_APP_API_URL;


const ListItem = (props) =>  {
    const [posts, setPosts] = useState([]);
    useEffect(() => {
        fetch(`${API_URL}/${props.endpoint}/`)
            .then((response) => response.json())
            .then((data) => {
                console.log(data);
                setPosts(data);
            })
            .catch((err) => {
                console.log(err.message);
            });
    }, [props.endpoint]);

    return (
        <div className="ListItem">
            <table>
                <thead>
                    <tr>
                        <th>Id</th> <th>Name</th>
                    </tr>
                </thead>
                <tbody>
                    {posts.map((post) => {
                        return (<tr key={post.id}><td>{post.id}</td><td>{post.name}</td></tr>)
                    })
                    }
                </tbody>
            </table>
        </div>
    );
};
export default ListItem;
